


import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ProfileTab = ({ instagramURL }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!instagramURL || instagramURL.trim() === "") {
      setError("Please add your Instagram URL to see profile statistics.");
      return;
    }

    const fetchUserData = async () => {
      setLoading(true);
      setError(""); // Clear any previous error
      try {
        const response = await fetch(
          "https://server-side-influencer.onrender.com/influencer/add-link",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ instaUrl: instagramURL }),
          }
        );

        const result = await response.json();

        if (result?.data) {
          setUser(result.data);
        } else {
          setError("No user data found.");
        }
      } catch (err) {
        console.error("Error fetching profile:", err);
        setError("Error loading profile.");
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [instagramURL]);

  const formatNumber = (num) => {
    if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + "M";
    if (num >= 1_000) return (num / 1_000).toFixed(1) + "K";
    return num?.toString();
  };

  if (error) {
    return (
      <div className="bg-white shadow-md p-8 rounded-lg w-full text-center">
        <p className="text-red-600 font-semibold">{error}</p>
      </div>
    );
  }

  if (loading || !user) {
    return (
      <div className="flex flex-col sm:flex-row items-center bg-white shadow-md p-8 rounded-lg w-full">
        <div className="flex-shrink-0 mb-6 sm:mb-0 sm:mr-10">
          <Skeleton circle height={160} width={160} />
        </div>
        <div className="w-full sm:w-auto">
          <Skeleton height={32} width={200} className="mb-4" />
          <Skeleton height={24} width={180} className="mb-2" />
          <Skeleton height={24} width={150} className="mb-2" />
          <Skeleton height={24} width={100} className="mb-2" />
          <Skeleton height={24} width={100} className="mb-2" />
          <Skeleton height={24} width={120} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col sm:flex-row items-center bg-white shadow-md p-8 rounded-lg w-full">
      {/* Profile Picturesss */}
      <div className="flex-shrink-0 mb-6 sm:mb-0 sm:mr-10">
        <img
          src={user.image || "https://via.placeholder.com/150"}
          alt="Profile"
          className="w-40 h-40 rounded-full object-cover border-4 border-gray-300"
        />
      </div>

      {/* User Details */}
      <div className="text-left w-full sm:w-auto text-lg sm:text-xl text-gray-800">
        <h2 className="text-2xl sm:text-3xl font-bold mb-4">
          {user.name || "Unnamed"}
        </h2>
        <p className="mb-2">
          <span className="font-semibold">Username:</span> {user.screenName}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Account Type:</span>{" "}
          {user.type || "N/A"}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Followers:</span>{" "}
          {formatNumber(user.usersCount) || "N/A"}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Quality Score:</span>{" "}
          {user.qualityScore?.toFixed(2) || "N/A"}
        </p>
        <p>
          <span className="font-semibold">Average Likes:</span>{" "}
          {formatNumber(user.avgLikes) || "N/A"}
        </p>
      </div>
    </div>
  );
};

export default ProfileTab;
